import React from "react";
import loadable from "@loadable/component";
import APIS from "../constant/Endpoint";
import usePatchHook from "../customHooks/usePatchHook";
const OverviewComponent = loadable(
  () => import("../Components/Overview/index")
);
const Overview = () => {
  const { mutateAsync: patchStatus, isLoading } = usePatchHook({
    queryKey: ["form-builder"],
    navigateURL: "",
  });
  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.FORM}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsPublic = async (value: boolean, id: any) => {
    const payload = {
      is_public: value,
    };
    const url = `${APIS.FORM}${id}/`;
    const formData = payload;
    try {
      await patchStatus({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <OverviewComponent
      handleIsActive={handleIsActive}
      handleIsPublic={handleIsPublic}
    />
  );
};

export default Overview;
